angular.module('gis', [])
    .controller('gisController', ['$scope', '$rootScope', '$sce', '$location', '$routeParams', 'gisService', 'infraestructurasService', function ($scope, $rootScope, $sce, $location, $routeParams, gisService, infraestructurasService) {


        if ($rootScope.categoria == '21') {
            infraestructurasService.getDañosPorGravedadTodosLosTuneles($rootScope.categoria, $rootScope.usuario)
                .then(function (response) {
                    var data = response.data;
                    $scope.infraestructuras = data;

                    for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                        if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Verde")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                        else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Amarillo")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                        else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Naranja")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                        else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Rojo")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                        $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);
                    }


                    var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                    var myOptions = {
                        zoom: 14,
                        center: myLatlng,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    };

                    $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                    var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                    angular.forEach($scope.infraestructuras, function (infraestructura) {
                        myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                        if (infraestructura.IndiceInfraestructura.Color == "Rojo") {
                            icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                            var markerGreen = new google.maps.Marker({
                                position: myLatlng,
                                title: infraestructura.Descripcion,
                                draggable: false,
                                icon: {
                                    url: icono
                                }
                            });
                            markerGreen.setMap($scope.map);
                        }
                        else {
                            if (infraestructura.IndiceInfraestructura.Color == "Naranja") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                var markerOrange = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerOrange.setMap($scope.map);
                            } else {
                                if (infraestructura.IndiceInfraestructura.Color == "Amarillo") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                    var markerYellow = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerYellow.setMap($scope.map);
                                }
                                else {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                    var markerRed = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerRed.setMap($scope.map);
                                }
                            }
                        }

                    });

                });
        }
        else {
            infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                .then(function (response) {
                    var data = response.data;
                    $scope.infraestructuras = data;

                    for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                        if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                        else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                        else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                        else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                            $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                        $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                        (function (infraestructura) {
                            setTimeout(function () {
                                const divTemporal = document.createElement("div");
                                divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                const script = divTemporal.querySelector("script");
                                const divWidget = divTemporal.querySelector("div");

                                if (script && divWidget) {
                                    const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                    if (container) {
                                        container.innerHTML = "";
                                        container.appendChild(divWidget);

                                        const newScript = document.createElement("script");
                                        newScript.type = "text/javascript";
                                        newScript.src = script.src;
                                        document.body.appendChild(newScript);
                                    }
                                }
                            }, 0);
                        })($scope.infraestructuras[i]);

                    }

                    var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                    var myOptions = {
                        zoom: 14,
                        center: myLatlng,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    };

                    $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                    var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                    angular.forEach($scope.infraestructuras, function (infraestructura) {
                        myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                        if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                            icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                            var markerGreen = new google.maps.Marker({
                                position: myLatlng,
                                title: infraestructura.Descripcion,
                                draggable: false,
                                icon: {
                                    url: icono
                                }
                            });
                            markerGreen.setMap($scope.map);
                        }
                        else {
                            if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                var markerOrange = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerOrange.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                    var markerYellow = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerYellow.setMap($scope.map);
                                }
                                else {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                    var markerRed = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerRed.setMap($scope.map);
                                }
                            }
                        }

                    });

                });
        }
        //gisService.getGIS($routeParams.id)
        //    .then(function (response) {
        //        var data = response.data;
        //        //$scope.modeloUrl = $sce.trustAsResourceUrl(data.Ruta);
        //        //$scope.gisUrl = $sce.trustAsHtml(data.Ruta);
                
        //        //$scope.modeloUrl = data.Ruta;
        //    });
    }
]);